import * as React from 'react'

const GithubIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
        <g data-name="Github 1">
            <g data-name="&lt;Group&gt;">
                <path
                    fill="none"
                    strokeLinecap="round"
                    stroke="#a1a1aa"
                    strokeLinejoin="round"
                    d="M12 .5A11.5 11.5 0 00.5 12a11.82 11.82 0 009 11.5v-3h-1c-2.62 0-3.54-4-5-4 2.79 0 3.33 2 5 2a.89.89 0 001-1v-.35c-2.91-.82-5-3-5-5.65a5.26 5.26 0 011.57-3.66A3.16 3.16 0 016.5 4.5 5.26 5.26 0 018.88 6a9.14 9.14 0 016.24 0 5.26 5.26 0 012.38-1.5 3.16 3.16 0 01.43 3.34 5.26 5.26 0 011.57 3.66c0 2.74-2.29 5-5.42 5.76a4.68 4.68 0 01.42 2.24v4a11.82 11.82 0 009-11.5A11.5 11.5 0 0012 .5z"
                    data-name="&lt;Path&gt;"
                ></path>
            </g>
        </g>
    </svg>
)

export default GithubIcon
